import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { rememberRouteParams } from '@/utils/route-params-memory'

/**
 * Records the query string of every visited dashboard page so breadcrumb links
 * can send the user back to the exact filtered view they came from.
 * Mounted once, in the app shell.
 */
const useRememberRouteParams = () => {
  const { pathname, search } = useLocation()

  useEffect(() => {
    rememberRouteParams(pathname, search)
  }, [pathname, search])
}

export default useRememberRouteParams
